<app-input
	label="Aposta {{ betKey }}:"
	[value]="value"
	(valueChange)="valueChange.emit($event)"
	/>